'use strict';

angular.module('MW.Framework.ICMEntitlementService', ['MW.Influencers.IcmDialogService',
        'MW.Framework.TranslationService',
        'MW.Framework.ErrorMessageService',
        'Configuration',
        'MW.Framework.LimitEntitlement',
        'MW.Framework.ToggleEntitlement',
        'MW.Influencers.AnalyticsService',
        'MW.Framework.CoreCompanyService'
    ])
    .service('ICMEntitlementService', ['$http',
        '$log',
        '$q',
        'DialogService',
        'translationService',
        '$window',
        '$injector',
        'LimitEntitlement',
        'ToggleEntitlement',
        'ErrorMessageService',
        'AnalyticsService',
        'ENTITLEMENT_MGR_URL',
        'ENTITLEMENTS_SERVICE_URI_V6',
        'MAX_EXPORT_LIMIT',
        'DEFAULT_EXPORT_LIMIT',
        function ($http,
            $log,
            $q,
            DialogService,
            translationService,
            $window,
            $injector,
            LimitEntitlement,
            ToggleEntitlement,
            ErrorMessageService,
            AnalyticsService,
            ENTITLEMENT_MGR_URL,
            ENTITLEMENTS_SERVICE_URI_V6,
            MAX_EXPORT_LIMIT,
            DEFAULT_EXPORT_LIMIT) {
            var entitlements = {},
                toggleType = 'toggle',
                limitType = 'limit',
                icmRecipientsPerDay,
                icmRecipientsPerDistribution,
                icmContactExportLimit,
                influencerApp,
                icmCountries,

                // methods
                registerEntitlement,
                getEntitlements,
                showEntitlementError,
                showUpgradeMessage,
                setDefaultOptions;

            //
            // Internal
            //
            showEntitlementError = function showEntitlementError(err) {
                var error = ErrorMessageService.getErrorMessage('errorProcessingByFairhair');
                $log.error('Error with entitlement service: ' + err);
                DialogService.flashError(translationService.getLocalizedString(error.message), error.timeout);
            };

            showUpgradeMessage = function showUpgradeMessage(entitlementId) {
                var scope,
                    payload,
                    entitlement = entitlements[entitlementId];

                scope = entitlement.upgradeMessageScope;
                scope.name = translationService.getLocalizedString(entitlement.name);

                payload = {
                    content: translationService.getLocalizedString(entitlement.upgradeMessage, scope),
                    okText: 'OK',
                    cancelText: 'Upgrade Now'
                };

                //This dialog is slightly different in behavior of hiding and success value
                //success will be false for confirm, true for reject, and false when the user clicks outside of the dialog
                DialogService.dialog({
                    title: translationService.getLocalizedString('Alert'),
                    template: 'icm-gaf-legacy/views/partials/dialog_confirm',
                    payload: payload,
                    callback: function (result) {
                        if (!result.success) {
                            $window.open('/settings/account', '_blank');
                        }
                    },
                    callbackOnCancel: true,
                    closeOnBackgroundClick: false
                });
            };

            /**
             * Registers a new entitlement.
             *
             * @param name
             * @param options
             */
            registerEntitlement = function registerEntitlement(type, id, name, options) {
                if (id in entitlements) {
                    $log.error('Cannot register the "' + id + '" entitlement twice');
                    return;
                }

                options = options || {};
                setDefaultOptions(options);

                if (type === limitType) {
                    entitlements[id] = new LimitEntitlement(id, name, options);
                }
                else if (type === toggleType) {
                    entitlements[id] = new ToggleEntitlement(id, name, options);
                }

                return entitlements[id];
            };

            /**
             * Sets default options for a new entitlement.  Mainly just sets up callbacks
             * for entitlement violation actions
             *
             * @param options
             * @returns {{TOGGLE_TYPE: string, LIMIT_TYPE: string, getEntitlement: getEntitlement, getEntitlements: getEntitlements, registerEntitlement: registerEntitlement}}
             */
            setDefaultOptions = function setDefaultOptions(options) {
                if (!options.onViolated) {
                    options.onViolated = function onViolatedCallback(callbackOptions) {
                        callbackOptions = angular.extend(angular.copy(this.options), callbackOptions || {});
                        if (!callbackOptions.suppressUpgradeMessage) {
                            showUpgradeMessage(this.id);
                        }
                    };
                }

                if (!options.onError) {
                    options.onError = function onErrorCallback() {
                        showEntitlementError();
                    };
                }
            };

            /**
             * Retrieves the list of all registered entitlements.  
             *
             * @returns {{}}
             */
            getEntitlements = function getEntitlements() {
                var CoreCompanyService = $injector.get('CoreCompanyService');
                return CoreCompanyService.getCurrent(true).then(function afterCompany(company) { 
                    return $http({url: ENTITLEMENTS_SERVICE_URI_V6 + '/company/' + company._id + '/entitlements/all', headers: {'x-client-name': 'icm-web'} });
                }).then(function afterEntitlement(response) {
                    var entitlementList = {},
                        entitlements = {};
                    if (response.data) {
                        angular.forEach(response.data, function (data, key) {
                            if (response.data[key]) {
                                entitlements[key] = data.value;
                            }
                            entitlementList[key] = entitlements[key];
                        });
                    }
                    return entitlementList;
                });
            };

            function fetchV6Entitlement(entitlementMatch) {
                return $q(function (resolve, reject) {
                    var CoreCompanyService = $injector.get('CoreCompanyService');

                    return CoreCompanyService.getCurrent(true).then(function afterCompany(company) {
                        return $http({url: ENTITLEMENTS_SERVICE_URI_V6 + '/company/' + company._id + '/' + entitlementMatch, headers: {'x-client-name': 'icm-web'} });
                    }).then(function afterEntitlement(response) {
                        resolve(response.data);
                    }).catch(function onError(error) {
                        if (error.data) {
                            reject(error.data);
                        } else {
                            reject(error);
                        }
                    });
                });
            }

            function getInfluencerAppEntitlement() {
                return $q(function (resolve, reject) {
                    if (!influencerApp) {
                        return fetchV6Entitlement('influencerApp').then(function afterFetchEntitlement(entitlement) {
                            influencerApp = (entitlement && entitlement.influencerApp && entitlement.influencerApp.value) ? entitlement.influencerApp.value : false;
                            resolve(influencerApp);
                        }).catch(function onError(error) {
                            reject(error);
                        });
                    }
                    resolve(influencerApp);
                });
            }

            /**
             * Responsible for getting list of Influencer Database entitled countries for a company
             * @returns {Promise|*|!webdriver.promise.Promise}
             */
            function getIcmCountriesEntitlement() {
                return $q(function (resolve, reject) {
                    if (!icmCountries) {
                        return fetchV6Entitlement('icm-').then(function afterFetchEntitlement(list) {
                            icmCountries = list;
                            resolve(icmCountries);
                        }).catch(function onError(error) {
                            reject(error);
                        });
                    }
                    resolve(icmCountries);
                });
            }

            function getIcmContactExportLimit() {
                return $q(function (resolve) {
                   if (!icmContactExportLimit) {
                       return fetchV6Entitlement('icmContactExportLimit').then(function afterFetchEntitlement(entitlement) {
                           if(entitlement.icmContactExportLimit && entitlement.icmContactExportLimit.value > MAX_EXPORT_LIMIT){
                               icmContactExportLimit = MAX_EXPORT_LIMIT;
                           } else if(entitlement.icmContactExportLimit && entitlement.icmContactExportLimit.value < DEFAULT_EXPORT_LIMIT){
                               icmContactExportLimit = DEFAULT_EXPORT_LIMIT;
                           } else {
                               icmContactExportLimit = entitlement.icmContactExportLimit.value;
                           }
                           resolve(icmContactExportLimit);
                       }).catch(function onError() {
                           resolve(DEFAULT_EXPORT_LIMIT);
                       });
                   }
                   resolve(icmContactExportLimit);
                 });
            }

            /**
             * Responsible for getting the limit of a single distributions recipients
             * @returns {Promise|*|!webdriver.promise.Promise}
             */
            function getIcmRecipientsPerDistribution(defaultValue) {
                return $q(function (resolve, reject) {
                    if (!icmRecipientsPerDistribution) {
                        return fetchV6Entitlement('icmRecipientsPerDistribution').then(function afterFetchEntitlement(entitlement) {
                            icmRecipientsPerDistribution = (entitlement && entitlement.icmRecipientsPerDistribution && entitlement.icmRecipientsPerDistribution.value) ? entitlement.icmRecipientsPerDistribution.value : defaultValue;
                            resolve(icmRecipientsPerDistribution);
                        }).catch(function onError(error) {
                            reject(error);
                        });
                    }
                    resolve(icmRecipientsPerDistribution);
                });
            }

            function getIcmRecipientsPerDayLimit(defaultValue) {
                return $q(function (resolve, reject) {
                    if (!icmRecipientsPerDay) {
                        return fetchV6Entitlement('icmRecipientsPerDay').then(function afterFetchEntitlement(entitlement) {
                            icmRecipientsPerDay = (entitlement && entitlement.icmRecipientsPerDay && entitlement.icmRecipientsPerDay.value) ? entitlement.icmRecipientsPerDay.value : defaultValue;
                            resolve(icmRecipientsPerDay);
                        }).catch(function onError(error) {
                            reject(error);
                        });
                    }
                    resolve(icmRecipientsPerDay);
                });
            }

            return {
                TOGGLE_TYPE: toggleType,
                LIMIT_TYPE: limitType,
                getEntitlements: getEntitlements,
                registerEntitlement: registerEntitlement,
                getIcmCountriesEntitlement: getIcmCountriesEntitlement,
                getIcmRecipientsPerDayLimit: getIcmRecipientsPerDayLimit,
                getIcmRecipientsPerDistribution: getIcmRecipientsPerDistribution,
                getInfluencerAppEntitlement: getInfluencerAppEntitlement,
                getIcmContactExportLimit: getIcmContactExportLimit
            };
        }
    ]);
